'use client';

import { c as _c } from "react/compiler-runtime";
import BreadCrumbs from '@components/breadcrumbs/BreadCrumbs';
import ROUTES from '@lib/constants/routes';
import ScrollHelperStandart from '@lib/tools/helpers/ScrollHelperStandart';
import { useViewport } from '@lib/tools/hooks/useViewport';
import { useRef } from 'react';
import GalleryItem from '../gallery-item/GalleryItem';
import { ProgressPhotosSlider } from '../progress-photos-slider/ProgressPhotosSlider';
import style from './ProgressOnePage.module.scss';
export const ProgressOnePageComponent = t0 => {
  const $ = _c(29);
  const {
    data,
    deviceType
  } = t0;
  const {
    isMobile,
    isDesktop
  } = deviceType;
  const containerRef = useRef(null);
  const {
    isLandscape
  } = useViewport();
  const formatSlug = _temp;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      id: 1,
      text: "\u0413\u043B\u0430\u0432\u043D\u0430\u044F",
      link: ROUTES.root
    };
    t2 = {
      id: 2,
      text: "\u0414\u0438\u043D\u0430\u043C\u0438\u043A\u0430 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430",
      link: ROUTES.progress.root
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  const t3 = formatSlug(data.slug);
  let t4;
  if ($[2] !== t3) {
    t4 = {
      color: "#636363",
      crumbs: [t1, t2, {
        id: 3,
        text: t3
      }]
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const breadCrumbsApi = t4;
  let t5;
  if ($[4] !== data.mimeType) {
    t5 = data?.mimeType?.findIndex(_temp2) ?? -1;
    $[4] = data.mimeType;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const videoIndex = t5;
  const hasVideo = videoIndex >= 0;
  const mainUrl = hasVideo ? data?.fileUrl?.[videoIndex] : null;
  const mainMime = hasVideo ? data?.mimeType?.[videoIndex] : null;
  let t6;
  if ($[6] !== data.fileUrl || $[7] !== data.mimeType) {
    t6 = data?.fileUrl?.map((url, idx) => ({
      url,
      mime: data.mimeType?.[idx]
    })).filter(_temp3).map(_temp4) ?? [];
    $[6] = data.fileUrl;
    $[7] = data.mimeType;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const images = t6;
  let t7;
  if ($[9] !== breadCrumbsApi || $[10] !== hasVideo || $[11] !== images || $[12] !== isDesktop || $[13] !== isMobile || $[14] !== mainMime || $[15] !== mainUrl) {
    t7 = !isMobile && <><div ref={containerRef}><><div className={style.content}><div className={style.intro}><div className={style.introInner}><BreadCrumbs item={breadCrumbsApi} /></div>{isDesktop && <span className={style.lineWrapper}><svg className={style.line} width="747" height="735" viewBox="0 0 747 735" fill="none" xmlns="http://www.w3.org/2000/svg"><path className={style.path} d="M0.620106 560L327.391 699.673C320.794 682.407 263.081 536.502 336.953 498.106C526.292 399.697 753.025 760.313 642.749 732.967C536.286 706.567 360.748 121.251 746.229 -211" stroke="#E1E1E1" /></svg></span>}</div>{hasVideo && <div className={style.gallery}><div className={style.gallery__main}><GalleryItem url={mainUrl} mimeType={mainMime} /></div></div>}{images.length > 0 && <ProgressPhotosSlider images={images} isMobile={isMobile} />}</div></></div></>;
    $[9] = breadCrumbsApi;
    $[10] = hasVideo;
    $[11] = images;
    $[12] = isDesktop;
    $[13] = isMobile;
    $[14] = mainMime;
    $[15] = mainUrl;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== breadCrumbsApi || $[18] !== hasVideo || $[19] !== images || $[20] !== isLandscape || $[21] !== isMobile || $[22] !== mainMime || $[23] !== mainUrl) {
    t8 = isMobile && !isLandscape && <><div ref={containerRef}><><div className={style.content}><div className={style.introInner}><BreadCrumbs item={breadCrumbsApi} /></div>{hasVideo && <div className={style.gallery}><div className={style.gallery__main}><GalleryItem url={mainUrl} mimeType={mainMime} /></div></div>}{images.length > 0 && <ProgressPhotosSlider images={images} isMobile={isMobile} />}</div></></div></>;
    $[17] = breadCrumbsApi;
    $[18] = hasVideo;
    $[19] = images;
    $[20] = isLandscape;
    $[21] = isMobile;
    $[22] = mainMime;
    $[23] = mainUrl;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ScrollHelperStandart />;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t7 || $[27] !== t8) {
    t10 = <>{t7}{t8}{t9}</>;
    $[26] = t7;
    $[27] = t8;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
};
function _temp(slug) {
  const [date, queue] = slug.split("-");
  const day = date.slice(0, 2);
  const month = date.slice(2, 4);
  const year = date.slice(4);
  return `${day}.${month}.${year}-${queue}`;
}
function _temp2(mime) {
  return mime?.includes("video");
}
function _temp3(item) {
  return item.mime?.includes("image");
}
function _temp4(item_0) {
  return item_0.url;
}